var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%", height: "100%" } }, [
    _vm.podId
      ? _c("iframe", {
          staticStyle: { display: "block", border: "none" },
          attrs: { src: _vm.fullPath, height: "100%", width: "100%" }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }